import { createContext, useContext } from 'react';
import i18next from 'i18next';
import { useAppDispatch } from 'redux/store-hooks';
import { languageChanged } from 'redux/slices/consent.slice';

export interface LanguageContextType {
  currentLanguage: string;
  setLanguage: (language: string) => void;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  const dispatch = useAppDispatch();

  if (context === undefined) {
    const fallbackLanguage = localStorage.getItem('language') || 'en';

    return {
      currentLanguage: fallbackLanguage,
      setLanguage: (language: string) => {
        localStorage.setItem('language', language);
        i18next.changeLanguage(language);
        dispatch(languageChanged(language));
      },
    };
  }

  return context;
};
